import { render } from "./TaskEditor.vue?vue&type=template&id=0e24c8b7"
import script from "./TaskEditor.vue?vue&type=script&lang=js"
export * from "./TaskEditor.vue?vue&type=script&lang=js"

import "./TaskEditor.vue?vue&type=style&index=0&id=0e24c8b7&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__